'use strict';

var ConfigurationLegAssignmentTransformerFactory = function ConfigurationLegAssignmentTransformerFactory(DataTransformer) {
  function ConfigurationLegAssignmentTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-leg-assignment-mode';
  }
  ConfigurationLegAssignmentTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationLegAssignmentTransformer.constructor = ConfigurationLegAssignmentTransformer;
  ConfigurationLegAssignmentTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationLegAssignmentTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationLegAssignmentTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationLegAssignmentTransformer.prototype.transform = function (data) {
    return data.domain.flattenedLegEntities;
  };
  return ConfigurationLegAssignmentTransformer;
};
ConfigurationLegAssignmentTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ConfigurationLegAssignmentTransformerFactory;